export const iconFontAwesomeDisasterCrisisHouseTsunami = (
	<i className="fa-solid fa-house-tsunami"></i>
);
